module.exports = __webpack_public_path__ + "static/media/umrah-package-1.dbadda96.jpg";